<template>
    <div class="productDetailWrap fc">
        <mt-swipe :auto="0">
            <mt-swipe-item v-for="(item, index) in picList" :key="index">
                <img v-show="item.logo" :src="item.logo" alt />
            </mt-swipe-item>
        </mt-swipe>
        <div class="basicInfo fc">
            <span>
                ￥
                <strong>{{productInfo.priceDesc}}</strong>
            </span>
            <h2>{{productInfo.name}}</h2>
        </div>
        <div class="desp fc">
            <h3>商品介绍</h3>
            <div class="productDesp" v-html="productInfo.introduction"></div>
        </div>
        <div class="btmBar fr ac">
            <div class="fc ac jc">
                <img src="../../../static/imgs/mall/contact.png" alt />
                <span>联系客服</span>
            </div>
            <div class="fc ac jc" @click="$router.push('/cart')">
                <div class="iconWrap">
                    <img src="../../../static/imgs/mall/shopping_cart.png" alt />
                    <span v-show="cartNum" class="redDot">{{cartNum}}</span>
                </div>
                <span>购物车</span>
            </div>
            <button @click="openLayer('cart')" class="cartBtn">加入购物车</button>
            <button @click="openLayer('buy')" class="buyBtn">立即购买</button>
        </div>
        <transition name="purchaseLayer">
            <div v-show="showLayer" class="layer fc">
                <div class="productInfo fr ac">
                    <img class="productImg" :src="productInfo.logo" alt />
                    <div class="infoBox fc jsb">
                        <div class="fr jsb">
                            <h4>{{productInfo.name}}</h4>
                            <img
                                class="closeIcon"
                                @click="toggleLayer"
                                src="../../../static/imgs/mall/close.png"
                                alt
                            />
                        </div>
                        <span class="price">
                            ￥
                            <strong>{{selectedSku.sellPrice ? selectedSku.sellPrice : productInfo.priceDesc}}</strong>
                        </span>
                        <span class="attr">选择 {{productInfo.attrName}}</span>
                    </div>
                </div>
                <h3>{{productInfo.attrName}}</h3>
                <div class="options fc">
                    <span
                        v-for="(item, index) in skuList"
                        :key="index"
                        :class="activeSkuIdx == index ? 'active' : ''"
                        @click="selectSku(index)"
                    >{{item.name}}</span>
                </div>
                <div class="number fr ac jsb">
                    <p>
                        选择数量
                        <span>(库存{{selectedSku.stock}})</span>
                    </p>
                    <div class="operate">
                        <span @click="minusNum">-</span>
                        <strong>{{productNum}}</strong>
                        <span @click="addNum">+</span>
                    </div>
                </div>
                <div class="menu fr ac jsb">
                    <p class="total">
                        合计：
                        <strong>{{selectedSku.sellPrice * productNum}}</strong>
                        <span>元</span>
                    </p>
                    <button v-show="layerType == 'cart'" @click="addToCart" class="purchase">加入购物车</button>
                    <button v-show="layerType == 'buy'" @click="confirm" class="purchase">去下单</button>
                </div>
            </div>
        </transition>
        <div @click="toggleLayer" v-show="showLayer" class="shade"></div>
    </div>
</template>

<script>
import { Swipe, SwipeItem, Toast } from "mint-ui";
export default {
    data() {
        return {
            showLayer: false,
            layerType: "",
            productId: this.$route.query.productid
                ? this.$route.query.productid
                : 852,
            productInfo: {},
            picList: [],
            skuList: [],
            activeSkuIdx: 0,
            selectedSku: {},
            productNum: 1,
            cartNum: 0
        };
    },
    components: {},
    created() {
        this.getProductInfo();
        this.getPicList();
        this.getSkuList();
        this.getCartNum();
    },
    methods: {
        getProductInfo() {
            this.$post({
                method: "mall.product.detail",
                productId: this.productId
            }).then(res => {
                if (res.success) {
                    this.productInfo = res.data;
                }
            });
        },
        getPicList() {
            this.$post({
                method: "mall.product.picture.list",
                productId: this.productId
            }).then(res => {
                if (res.success) {
                    this.picList = res.data;
                }
            });
        },
        getSkuList() {
            this.$post({
                method: "mall.product.sku.list",
                productId: this.productId
            }).then(res => {
                if (res.success) {
                    this.skuList = res.data;
                    this.selectedSku = res.data[this.activeSkuIdx];
                }
            });
        },
        selectSku(idx) {
            this.activeSkuIdx = idx;
            this.selectedSku = this.skuList[idx];
        },
        minusNum() {
            if (this.productNum > 1) {
                this.productNum--;
            }
        },
        addNum() {
            if (this.productNum < this.selectedSku.stock) {
                this.productNum++;
            }
        },
        toggleLayer() {
            this.showLayer = !this.showLayer;
        },
        openLayer(type) {
            this.showLayer = true;
            this.layerType = type;
        },
        // 加入购物车
        addToCart() {
            this.$post({
                method: "member.mall.cart.add",
                auth_code: this.getLocal("auth_code"),
                skuId: this.selectedSku.skuId,
                qty: this.productNum
            }).then(res => {
                if (res.success) {
                    this.showLayer = false;
                    Toast({
                        message: "添加成功",
                        position: "middle",
                        duration: 2000,
                        className: "toastBox"
                    });
                    this.cartNum = res.data
                }
            });
        },
        confirm() {
            let productList = [];
            let productObj = this.productInfo, skuObj = this.selectedSku;
            productObj.productName = productObj.name;
            delete productObj.name;
            skuObj.skuName = skuObj.name;
            delete skuObj.name;
            let obj = Object.assign(productObj, skuObj);
            obj.qty = this.productNum;
            productList.push(obj)
            this.$router.push({path: "/mallOrderInfo", query: {productList: JSON.stringify(productList), origin: "product"}})
        },
        getCartNum(){
            this.$post({
                method: "member.mall.cart.list",
                auth_code: this.getLocal("auth_code")
            }).then(res => {
                if(res.success){
                    this.cartNum = res.data.length
                }
            })
        }
    }
};
</script>
<style lang="scss">
.productDetailWrap {
    background: #fff;
    .mint-swipe {
        width: 100%;
        height: 750px;
        img {
            width: 100%;
            height: 750px;
        }
    }
    .basicInfo {
        padding: 30px;
        box-sizing: border-box;
        span {
            color: #fe5200;
            font-size: 28px;
            margin-bottom: 10px;
            strong {
                font-size: 38px;
            }
        }
        h2 {
            font-size: 32px;
            font-weight: bold;
            line-height: 46px;
        }
    }
    .desp {
        width: 100%;
        padding: 0 30px;
        box-sizing: border-box;
        h3 {
            font-size: 28px;
            line-height: 100px;
            font-weight: bold;
        }
        .productDesp {
            padding-bottom: 100px;
            p {
                font-size: 28px;
                line-height: 50px;
                img {
                    width: 100%;
                }
            }
        }
    }
    .btmBar {
        position: fixed;
        bottom: 0;
        width: 100%;
        height: 100px;
        z-index: 2;
        background: #fff;
        div {
            width: 155px;
            height: 100px;
            img {
                width: 40px;
                height: 40px;
                margin-bottom: 10px;
            }
            .iconWrap {
                width: 40px;
                height: 40px;
                margin-bottom: 10px;
                position: relative;
                .redDot {
                    position: absolute;
                    top: -10px;
                    right: -12px;
                    min-width: 25px;
                    height: 25px;
                    text-align: center;
                    line-height: 25px;
                    background: red;
                    color: #fff;
                    font-size: 20px;
                    border-radius: 50%;
                    padding: 0 5px;
                }
            }
            span {
                font-size: 20px;
            }
        }
        .cartBtn,
        .buyBtn {
            width: calc(50% - 155px);
            color: #fff;
            height: 100px;
            line-height: 100px;
            font-size: 32px;
        }
        .cartBtn {
            background: #fc0;
        }
        .buyBtn {
            background: #e42f46;
        }
    }
    .layer {
        position: fixed;
        bottom: 0;
        width: 100%;
        background: #fff;
        z-index: 5;
        padding-top: 20px;
        border-radius: 20px 20px 0 0;
        .productInfo {
            width: 100%;
            padding: 30px;
            box-sizing: border-box;
            border-bottom: 1px solid #dededf;
            .productImg {
                width: 180px;
                height: 180px;
                margin-right: 20px;
            }
            .infoBox {
                width: calc(100% - 200px);
                height: 180px;
                div {
                    h4 {
                        width: calc(100% - 50px);
                        font-size: 30px;
                        line-height: 40px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                    }
                    .closeIcon {
                        width: 36px;
                        height: 36px;
                    }
                }
                .price {
                    font-size: 34px;
                    color: #ff6969;
                    strong {
                        font-size: 38px;
                    }
                }
                .attr {
                    font-size: 28px;
                }
            }
        }
        h3 {
            width: 100%;
            padding: 0 30px;
            box-sizing: border-box;
            font-size: 30px;
            height: 100px;
            line-height: 100px;
            font-weight: bold;
        }
        .options {
            width: 100%;
            padding: 0 30px;
            box-sizing: border-box;
            font-size: 26px;
            span {
                min-width: 332px;
                max-width: 500px;
                height: 62px;
                line-height: 62px;
                border-radius: 31px;
                text-align: center;
                margin-top: 20px;
                background: #dededf;
                padding: 0 20px;
                box-sizing: border-box;
            }
            span:last-of-type {
                margin-bottom: 20px;
            }
            .active {
                background: #ffcc00;
                color: #fff;
            }
        }
        .number {
            width: 100%;
            padding: 0 30px;
            box-sizing: border-box;
            height: 100px;
            border-top: 1px solid #dededf;
            border-bottom: 1px solid #dededf;
            p {
                font-size: 30px;
                font-weight: bold;
                span {
                    font-size: 24px;
                    font-weight: normal;
                    color: #818181;
                }
            }
            .operate {
                span {
                    width: 48px;
                    height: 48px;
                    line-height: 46px;
                    text-align: center;
                    font-size: 40px;
                    border: 1px solid #dededf;
                    color: #dededf;
                    display: inline-block;
                }
                strong {
                    font-size: 30px;
                    width: 65px;
                    height: 48px;
                    line-height: 48px;
                    text-align: center;
                    display: inline-block;
                }
            }
        }
        .menu {
            width: 100%;
            padding: 30px 30px 30px 30px;
            box-sizing: border-box;
            .total {
                font-size: 30px;
                strong {
                    color: #fc0;
                    font-weight: bold;
                    font-size: 34px;
                }
                span {
                    font-size: 24px;
                    color: #818181;
                }
            }
            .purchase {
                width: 200px;
                height: 86px;
                border-radius: 10px;
                background: #fc0;
                text-align: center;
                line-height: 86px;
                color: #fff;
                font-size: 30px;
            }
        }
    }
    .purchaseLayer-enter {
        transform: translateY(960px);
    }
    .purchaseLayer-enter-active {
        transition: all 0.5s;
    }
    .shade {
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
        z-index: 4;
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/mall/productDetail.vue